import Extension from '@/tiptap/tiptap/Utils/Extension';
import { InputRule } from 'prosemirror-inputrules';
import { TextSelection } from 'prosemirror-state';

export default class ArrowReplacement extends Extension {
  get name() {
    return 'arrowReplacement';
  }

  get type() {
    return 'extension';
  }

  inputRules() {
    return [
      new InputRule(/->/, (state, _, start, end) => {
        const tr = state.tr.delete(start, end).insertText('→', start);
        tr.setSelection(TextSelection.create(tr.doc, start + 1));
        return tr;
      }, { undoable: false }),
      new InputRule(/<-/, (state, _, start, end) => {
        const tr = state.tr.delete(start, end).insertText('←', start);
        tr.setSelection(TextSelection.create(tr.doc, start + 1));
        return tr;
      }, { undoable: false }),
    ];
  }
}
